import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addpurchasereturndetail',
  templateUrl: './addpurchasereturndetail.component.html',
  styleUrls: ['./addpurchasereturndetail.component.css']
})
export class AddpurchasereturndetailComponent implements OnInit {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";


  purchasereturnBO: any = {}


  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  purchasereturnform = new FormGroup({
    purchasereturndetailsid: new FormControl(0),
    purchasereturnid: new FormControl(0),
    rawmaterialid: new FormControl(null, Validators.required),
    rawmaterialname: new FormControl(null),
    qty: new FormControl(null, Validators.required),
    unitprice: new FormControl(null, Validators.required),
    subtotal: new FormControl(null),
    uomid: new FormControl(null, Validators.required),
    taxid: new FormControl(null, Validators.required),
    taxname: new FormControl(null),
    taxrate: new FormControl(null),
    taxamt: new FormControl(null),
    cgsttaxrate: new FormControl(null),
    cgsttaxamt: new FormControl(null),
    sgsttaxrate: new FormControl(null),
    sgsttaxamt: new FormControl(null),
    igsttaxrate: new FormControl(null),
    igsttaxamt: new FormControl(null),
    taxable: new FormControl(null),
    nettotal: new FormControl(null),
    inactive: new FormControl(null),
  });


  formname: String = "PurchaseReturn";



  @Input() purchasereturndetailsid: number = 0
  @Input() purchasereturnid: number = 0

  @Input() purchasereturndetailsBO: any = {};

  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {

  }

  ngOnInit() {
    try {
      this.fnOnInitForm();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.purchasereturnform.reset();
      this.fnInitializeForm();

      this.fnGetRawmaterial();
      this.fnGetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }



  fnInitializeForm() {
    this.purchasereturnform.setValue({
      purchasereturndetailsid: this.purchasereturndetailsBO.purchasereturndetailsid,
      purchasereturnid: this.purchasereturndetailsBO.purchasereturnid,
      rawmaterialid: this.purchasereturndetailsBO.rawmaterialid,
      rawmaterialname: this.purchasereturndetailsBO.rawmaterialname,
      qty: this.purchasereturndetailsBO.qty,
      unitprice: this.purchasereturndetailsBO.unitprice,
      subtotal: this.purchasereturndetailsBO.subtotal,
      uomid: this.purchasereturndetailsBO.uomid,
      taxid: this.purchasereturndetailsBO.taxid,
      taxname: this.purchasereturndetailsBO.taxname,
      taxrate: this.purchasereturndetailsBO.taxrate,
      taxamt: this.purchasereturndetailsBO.taxamt,
      cgsttaxrate: this.purchasereturndetailsBO.cgsttaxrate,
      cgsttaxamt: this.purchasereturndetailsBO.cgsttaxamt,
      sgsttaxrate: this.purchasereturndetailsBO.sgsttaxrate,
      sgsttaxamt: this.purchasereturndetailsBO.sgsttaxamt,
      igsttaxrate: this.purchasereturndetailsBO.igsttaxrate,
      igsttaxamt: this.purchasereturndetailsBO.igsttaxamt,
      taxable: this.purchasereturndetailsBO.taxable,
      nettotal: this.purchasereturndetailsBO.nettotal,
      inactive: false,
    })
  }




  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var qty = this.purchasereturnform.get('qty').value;
    if (this.loginService.fnCheckZeroDetcimal(qty) === 0) {
      this.errtxt = "Quantity is cannot be empty"
      this.purchasereturnform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    // for (let row of this.purchasedetailscoll) {
    //   if (row.rawmaterialid > 0) {
    //     _detailscheck = true;
    //   }
    // }

    // if (!_detailscheck) {
    //   this.errtxt = "Purchase Details cannot be empty"
    //   this.purchasereturnform.controls['inactive'].setErrors({ 'notfound': true });
    //   _ischeck = true;
    // }
    // if (!_ischeck) {
    //   for (let row of this.purchasedetailscoll) {

    //     if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
    //       this.errtxt = "Quantity is cannot be empty"
    //       this.purchasereturnform.controls['inactive'].setErrors({ 'notfound': true });
    //       _ischeck = true;
    //     }

    //   }
    // }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.purchasereturnform.get('inactive')) {
      this.purchasereturnform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.purchasereturnform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          purchasereturndetailsid: this.purchasereturnform.get('purchasereturndetailsid').value,
          purchasereturnid: this.purchasereturnform.get('purchasereturnid').value,
          rawmaterialid: this.purchasereturnform.get('rawmaterialid').value,
          rawmaterialname: this.purchasereturnform.get('rawmaterialname').value,
          qty: this.purchasereturnform.get('qty').value,
          unitprice: this.purchasereturnform.get('unitprice').value,
          subtotal: this.purchasereturnform.get('subtotal').value,
          uomid: this.purchasereturnform.get('uomid').value,
          taxid: this.purchasereturnform.get('taxid').value,
          taxname: this.purchasereturnform.get('taxname').value,
          taxrate: this.purchasereturnform.get('taxrate').value,
          taxamt: this.purchasereturnform.get('taxamt').value,
          cgsttaxrate: this.purchasereturnform.get('cgsttaxrate').value,
          cgsttaxamt: this.purchasereturnform.get('cgsttaxamt').value,
          sgsttaxrate: this.purchasereturnform.get('sgsttaxrate').value,
          sgsttaxamt: this.purchasereturnform.get('sgsttaxamt').value,
          igsttaxrate: this.purchasereturnform.get('igsttaxrate').value,
          igsttaxamt: this.purchasereturnform.get('igsttaxamt').value,
          taxable: this.purchasereturnform.get('taxable').value,
          nettotal: this.purchasereturnform.get('nettotal').value,
        }

        var result = {
          'checkstatus': 'DONE',
          'data': data
        }

        this.emitData.emit(result);
        this.activeModal.close(true);



      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }




  //Close
  async fnCloseForm() {

    try {


      var result = {
        'checkstatus': 'CANCEL',
        'data': null
      }

      this.emitData.emit(result);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial() {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial()
        }, (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetTax() {
    this.isLoadingResult = true;

    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    var row = {
      purchasereturndetailsid: this.purchasereturnform.get('purchasereturndetailsid').value,
      purchasereturnid: this.purchasereturnform.get('purchasereturnid').value,
      rawmaterialid: this.purchasereturnform.get('rawmaterialid').value,
      rawmaterialname: this.purchasereturnform.get('rawmaterialname').value,
      qty: this.purchasereturnform.get('qty').value,
      unitprice: this.purchasereturnform.get('unitprice').value,
      subtotal: this.purchasereturnform.get('subtotal').value,
      uomid: this.purchasereturnform.get('uomid').value,
      taxid: this.purchasereturnform.get('taxid').value,
      taxname: this.purchasereturnform.get('taxname').value,
      taxrate: this.purchasereturnform.get('taxrate').value,
      taxamt: this.purchasereturnform.get('taxamt').value,
      cgsttaxrate: this.purchasereturnform.get('cgsttaxrate').value,
      cgsttaxamt: this.purchasereturnform.get('cgsttaxamt').value,
      sgsttaxrate: this.purchasereturnform.get('sgsttaxrate').value,
      sgsttaxamt: this.purchasereturnform.get('sgsttaxamt').value,
      igsttaxrate: this.purchasereturnform.get('igsttaxrate').value,
      igsttaxamt: this.purchasereturnform.get('igsttaxamt').value,
      taxable: this.purchasereturnform.get('taxable').value,
      nettotal: this.purchasereturnform.get('nettotal').value,
    }

    this.purchasereturndetailsBO.subtotal = row.qty * row.unitprice;

    this.purchasereturnform.patchValue({ 'subtotal': this.purchasereturndetailsBO.subtotal });
    //this.subtotal = this.subtotal + Number(row.subtotal)


    this.purchasereturndetailsBO.taxamt = Number(this.fnConvertDecimal(this.purchasereturndetailsBO.subtotal)) * Number(this.fnConvertDecimal(row.taxrate)) / 100
    this.purchasereturnform.patchValue({ 'taxamt': this.purchasereturndetailsBO.taxamt });

    //GST      
    this.purchasereturndetailsBO.cgsttaxamt = Number(this.fnConvertDecimal(this.purchasereturndetailsBO.taxamt)) / 2
    this.purchasereturndetailsBO.sgsttaxamt = Number(this.fnConvertDecimal(this.purchasereturndetailsBO.taxamt)) / 2
    this.purchasereturndetailsBO.igsttaxamt = 0

    this.purchasereturnform.patchValue({
      'cgsttaxamt': this.purchasereturndetailsBO.cgsttaxamt,
      'sgsttaxamt': this.purchasereturndetailsBO.sgsttaxamt,
      'igsttaxamt': this.purchasereturndetailsBO.igsttaxamt
    })

    this.purchasereturndetailsBO.taxable = Number(this.fnConvertDecimal(this.purchasereturndetailsBO.subtotal));
    this.purchasereturnform.patchValue({ 'taxable': this.purchasereturndetailsBO.taxable });

    this.purchasereturndetailsBO.nettotal = Number(this.fnConvertDecimal(this.purchasereturndetailsBO.taxable)) + Number(this.fnConvertDecimal(this.purchasereturndetailsBO.taxamt))
    this.purchasereturnform.patchValue({ 'nettotal': this.purchasereturndetailsBO.nettotal });
  }




  fnChangeRawmaterial() {

    var row = {
      rawmaterialid: this.purchasereturnform.get('rawmaterialid').value,
    }

    var _prodname = "", _uomid = null, _unitprice = 0, _taxid = null;

    for (let abo of this.rawmaterialColl) {
      if (row.rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;
        _uomid = abo.purchaseuomid;
        _taxid = abo.taxid;
      }
    }
    this.purchasereturndetailsBO.rawmaterialname = _prodname;
    this.purchasereturndetailsBO.unitprice = _unitprice;
    this.purchasereturndetailsBO.uomid = _uomid;
    this.purchasereturndetailsBO.taxid = _taxid;

    this.purchasereturnform.patchValue({ 'rawmaterialname': this.purchasereturndetailsBO.rawmaterialname });
    this.purchasereturnform.patchValue({ 'unitprice': this.purchasereturndetailsBO.unitprice });
    this.purchasereturnform.patchValue({ 'uomid': this.purchasereturndetailsBO.uomid });
    this.purchasereturnform.patchValue({ 'taxid': this.purchasereturndetailsBO.taxid });

    this.fnChangeTax()
  }


  fnChangeTax() {


    var row = {
      taxid: this.purchasereturnform.get('taxid').value,
    }



    var _taxname = "", _taxrate = 0;

    var _cgsttaxrate = 0, _sgsttaxrate = 0, _igsttaxrate = 0;

    for (let abo of this.taxColl) {
      if (row.taxid === abo.taxid) {
        _taxname = abo.taxname;
        _taxrate = abo.taxrate;
        _cgsttaxrate = abo.cgsttaxrate;
        _sgsttaxrate = abo.sgsttaxrate;
        _igsttaxrate = abo.igsttaxrate;
      }
    }
    this.purchasereturndetailsBO.taxname = _taxname;
    this.purchasereturndetailsBO.taxrate = _taxrate;
    this.purchasereturndetailsBO.cgsttaxrate = _cgsttaxrate;
    this.purchasereturndetailsBO.sgsttaxrate = _sgsttaxrate;
    this.purchasereturndetailsBO.igsttaxrate = _igsttaxrate;

    this.purchasereturnform.patchValue({ 'taxname': this.purchasereturndetailsBO.taxname });
    this.purchasereturnform.patchValue({ 'taxrate': this.purchasereturndetailsBO.taxrate });
    this.purchasereturnform.patchValue({ 'cgsttaxrate': this.purchasereturndetailsBO.cgsttaxrate });
    this.purchasereturnform.patchValue({ 'sgsttaxrate': this.purchasereturndetailsBO.sgsttaxrate });
    this.purchasereturnform.patchValue({ 'igsttaxrate': this.purchasereturndetailsBO.igsttaxrate });


    this.fnCalcDetails()

  }



  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.purchasereturndetailsBO.rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial();

    });
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}
